export function selectAllText(element) {
    var _a, _b;
    element.focus();
    if (element instanceof HTMLTextAreaElement) {
        element.select();
    }
    else {
        const range = document.createRange();
        range.selectNodeContents(element);
        (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        (_b = window.getSelection()) === null || _b === void 0 ? void 0 : _b.addRange(range);
        deselectOnClick();
    }
}
function deselectOnClick() {
    const listener = () => {
        var _a;
        (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        window.removeEventListener("click", listener, { capture: true });
    };
    window.addEventListener("click", listener, { capture: true });
}
